import React, { Component } from "react";
import "./App.css";
import { connect } from "react-redux";
import MainPage from "./components/mainpage";
import Signin from "./components/signin";
import Signup from "./components/signup";
import {
  MAIN_PAGE,
  LOGIN_PAGE,
  SIGN_UP_PAGE,
  VALIDATE_PAGE,
  FORGOTTEN_PAGE,
  FORGOTTEN_PAGE_RESET,
  OPTIONS_PAGE,
  RESET_PASSWORD_PAGE,
  DELETE_ACCOUNT_PAGE,
} from "./actions/routeactions";
import Validate from "./components/validate";
import { Snackbar, Grid } from "@mui/material";
import MuiAlert from "@mui/lab/Alert";
import { clearErrors, clearSuccess } from "./actions/erroractions";
import ForgottenPassword from "./components/forgottenpassword";
import ForgottenPasswordReset from "./components/forgottenpasswordreset";
import OptionsPage from "./components/OptionsPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import DeleteAccount from "./components/DeleteAccount";
import { autoLogin } from "./actions/loginactions";

const NO_AUTO_LOGIN = [
  LOGIN_PAGE,
  SIGN_UP_PAGE,
  VALIDATE_PAGE,
  FORGOTTEN_PAGE,
  FORGOTTEN_PAGE_RESET,
  OPTIONS_PAGE,
  RESET_PASSWORD_PAGE,
  DELETE_ACCOUNT_PAGE
];

class App extends Component {
  constructor() {
    super();
    this.renderPages = this.renderPages.bind(this);
    this.closeError = this.closeError.bind(this);
    this.renderErrors = this.renderErrors.bind(this);
    this.renderSuccess = this.renderSuccess.bind(this);
  }

  closeError(e) {
    const { dispatch } = this.props;
    dispatch(clearErrors());
    dispatch(clearSuccess());
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    setInterval(async () => {
      const { pageNo } = this.props;
      if (!NO_AUTO_LOGIN.includes(pageNo)) {
        dispatch(autoLogin());
      }
    }, 5000);
  }

  renderPages() {
    const { pageNo, args } = this.props;
    switch (pageNo) {
      case MAIN_PAGE:
        return <MainPage doLoad={args[0]} />;
      case LOGIN_PAGE:
        return <Signin />;
      case SIGN_UP_PAGE:
        return <Signup />;
      case VALIDATE_PAGE:
        return <Validate />;
      case FORGOTTEN_PAGE:
        return <ForgottenPassword />;
      case FORGOTTEN_PAGE_RESET:
        return (
          <ForgottenPasswordReset email={args[0]} securityQuestion={args[1]} />
        );
      case OPTIONS_PAGE:
        return <OptionsPage />;
      case RESET_PASSWORD_PAGE:
        return <ResetPasswordPage />;
      case DELETE_ACCOUNT_PAGE:
        return <DeleteAccount />;
      default:
        return <React.Fragment />;
    }
  }

  renderErrors() {
    const { errors } = this.props;

    return (
      <React.Fragment>
        {errors.map((error) => {
          return (
            <Grid item xs={12}>
              <MuiAlert elevation={6} variant="filled" severity="error">
                {error}
              </MuiAlert>
            </Grid>
          );
        })}
      </React.Fragment>
    );
  }

  renderSuccess() {
    const { successMessage } = this.props;

    return (
      <React.Fragment>
        <MuiAlert elevation={6} variant="filled" severity="success">
          {successMessage}
        </MuiAlert>
      </React.Fragment>
    );
  }

  render() {
    const { errors, successMessage } = this.props;

    return (
      <div className="App">
        {this.renderPages()}
        <Snackbar
          open={errors.length > 0 || successMessage}
          autoHideDuration={4000}
          onClose={this.closeError}
        >
          <Grid container spacing={2}>
            {errors.length > 0 ? this.renderErrors() : <React.Fragment />}
            {successMessage ? this.renderSuccess() : <React.Fragment />}
          </Grid>
        </Snackbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  pageNo: state.routes.pageNo,
  args: state.routes.args,
  errors: state.error.errors,
  successMessage: state.error.successMessage,
});

export default connect(mapStateToProps)(App);
